/** @jsxImportSource @emotion/react */
import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Card } from "primereact/card";
import { Column } from "primereact/column";
import { Toast } from "primereact/toast";
import { Skeleton } from "primereact/skeleton";
import { Accordion, AccordionTab } from "primereact/accordion";
import { Menu } from "primereact/menu";
import { confirmDialog } from "primereact/confirmdialog";
import { ConfirmDialog } from "primereact/confirmdialog";
import { Boton, Titulo, Formulario, accessAPI, downloadFile, Sidebar, SubidorArchivos, tituloBase, TablaFiltrable } from "../../../../shared";

const FILTROS_ELEMENTOS = [];
const SEARCH_FIELDS_ELEMENTOS = ["_nombreArchivo"];

const FILTROS_TEMPLATES = [];
const SEARCH_FIELDS_TEMPLATES = ["nombre", "tipo"];

export default function Templates() {
  const [loader, setLoader] = useState(true);
  const [templates, setTemplates] = useState([]);
  const [elementos, setElementos] = useState([]);
  const [loaderElementos, setLoaderElementos] = useState(true);
  const [selectedElemento, setSelectedElemento] = useState(null);
  const [loaderDescarga, setLoaderDescarga] = useState(false);
  const [sideBarNuevoTemplate, setSideBarNuevoTemplate] = useState(false);
  const [loaderNuevoTemplate, setLoaderNuevoTemplate] = useState(false);
  const [formNuevoTemplateKey, setFormNuevoTemplateKey] = useState(0);

  const toast = useRef(null);
  const menuElementoRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    document.title = "Templates";
    accessAPI(
      "GET",
      "admin/template",
      null,
      (respuesta) => {
        setTemplates(respuesta);
        setLoader(false);
      },
      (respuesta) => {
        toast.current?.show({
          severity: "error",
          summary: "Error",
          detail: respuesta[0]?.msg || "Error al cargar templates",
          sticky: true
        });
        setLoader(false);
      }
    );
    accessAPI(
      "GET",
      "admin/template/elemento",
      null,
      (respuesta) => {
        setElementos(respuesta);
        setLoaderElementos(false);
      },
      (respuesta) => {
        toast.current?.show({
          severity: "error",
          summary: "Error",
          detail: respuesta[0]?.msg || "Error al cargar elementos",
          sticky: true
        });
        setLoaderElementos(false);
      }
    );
    return () => (document.title = tituloBase());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function descargarElemento() {
    if (!selectedElemento || loaderDescarga) return;
    setLoaderDescarga(true);
    downloadFile(
      `admin/archivo/${selectedElemento.archivoId}`,
      selectedElemento.archivo?.nombredescarga || "elemento",
      () => setLoaderDescarga(false),
      (respuesta) => {
        setLoaderDescarga(false);
        toast.current?.show({
          severity: "error",
          summary: "Error",
          detail: respuesta[0]?.msg || "Error al descargar",
          sticky: true
        });
      }
    );
  }

  function eliminarElemento() {
    if (!selectedElemento) return;
    confirmDialog({
      message: `¿Eliminar el elemento "${selectedElemento.archivo?.nombredescarga}"?`,
      header: "Confirmar eliminación",
      icon: "pi pi-exclamation-triangle",
      acceptLabel: "Eliminar",
      rejectLabel: "Cancelar",
      acceptClassName: "p-button-danger",
      accept: () => {
        accessAPI(
          "DELETE",
          `admin/template/elemento/item/${selectedElemento.id}`,
          null,
          () => {
            setElementos((prev) =>
              prev.filter((e) => e.id !== selectedElemento.id)
            );
          },
          (respuesta) => {
            toast.current?.show({
              severity: "error",
              summary: "Error",
              detail: respuesta[0]?.msg || "Error al eliminar elemento",
              sticky: true
            });
          }
        );
      }
    });
  }

  function getMenuElementoItems() {
    const items = [
      {
        label: loaderDescarga ? "Descargando..." : "Descargar",
        icon: loaderDescarga ? "pi pi-spin pi-spinner" : "pi pi-download",
        command: descargarElemento
      },
      {
        label: "Eliminar",
        icon: "pi pi-trash",
        command: eliminarElemento
      }
    ];
    return items;
  }

  function crearTemplate(camposFormulario) {
    setLoaderNuevoTemplate(true);
    accessAPI(
      "POST",
      "admin/template",
      camposFormulario,
      (respuesta) => {
        setLoaderNuevoTemplate(false);
        setSideBarNuevoTemplate(false);
        navigate(`/template/${respuesta.id}`);
      },
      (respuesta) => {
        setLoaderNuevoTemplate(false);
        toast.current?.show({
          severity: "error",
          summary: "Error",
          detail: respuesta[0]?.msg || "Error al crear template",
          sticky: true
        });
      }
    );
  }

  const nuevoTemplateFormConfig = {
    secciones: [
      {
        campos: [
          {
            nombre: "nombre",
            tipoitemformularioid: 1,
            etiqueta: "Nombre",
            requerido: true
          }
        ]
      }
    ],
    botones: [
      {
        etiqueta: "Crear template",
        callback: crearTemplate,
        validar: true
      }
    ]
  };

  const datosElementos = (elementos || []).map((e) => ({
    ...e,
    _nombreArchivo: e.archivo?.nombredescarga
  }));

  return (
    <>
      <Toast ref={toast} position="top-center" />
      <ConfirmDialog />
      <Menu model={getMenuElementoItems()} popup ref={menuElementoRef} />

      <Sidebar
        visible={sideBarNuevoTemplate}
        onHide={() => setSideBarNuevoTemplate(false)}
        position="right"
        className="w-full lg:w-30rem md:w-30rem"
      >
        <Titulo>Nuevo template</Titulo>
        <Formulario
          key={formNuevoTemplateKey}
          config={nuevoTemplateFormConfig}
          loader={loaderNuevoTemplate}
        />
      </Sidebar>

      {(loader || loaderElementos) && (
        <div
          css={{
            marginTop: "2em",
            display: "flex",
            flexDirection: "column",
            gap: "0.5rem"
          }}
        >
          <div
            css={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "0.5rem"
            }}
          >
            <div css={{ display: "flex", alignItems: "center", gap: "1em" }}>
              <Skeleton width="2rem" height="2rem" shape="circle" />
              <Skeleton width="12rem" height="2.5rem" />
            </div>
          </div>
          <Skeleton width="100%" height="3.5rem" css={{ marginBottom: "0.5em" }} />
          <Card>
            <div css={{ display: "flex", flexDirection: "column", gap: "0.5rem" }}>
              <Skeleton width="100%" height="3rem" />
              {[...Array(5)].map((_, i) => (
                <Skeleton key={i} width="100%" height="3.5rem" />
              ))}
            </div>
          </Card>
        </div>
      )}

      {!loader && !loaderElementos && (
        <div>
          <Titulo
            urlVolver="/config"
            botones={
              <Boton
                callback={() => {
                  setFormNuevoTemplateKey((k) => k + 1);
                  setSideBarNuevoTemplate(true);
                }}
              >
                Nuevo template
              </Boton>
            }
          >
            Templates
          </Titulo>

          <Accordion
            css={{
              "& .p-accordion-header-link": { color: "black" },
              "& .p-toggleable-content": { transition: "max-height 0.15s ease" }
            }}
          >
            <AccordionTab header={"Elementos de template"}>
              <div
                css={{
                  display: "flex",
                  justifyContent: "flex-end",
                  marginBottom: "0.5em"
                }}
              >
                <SubidorArchivos
                  presignEndpoint="admin/archivo/presign"
                  confirmarEndpoint="admin/template/elemento/confirmar"
                  ubicacion="templates"
                  multiple
                  onSubido={(creados) =>
                    setElementos((prev) => [...prev, ...creados])
                  }
                />
              </div>
              <TablaFiltrable
                value={datosElementos}
                filtros={FILTROS_ELEMENTOS}
                searchFields={SEARCH_FIELDS_ELEMENTOS}
                anchoBusqueda="33%"
                nombreArchivo="elementos_template"
                stripedRows
                rows={10}
                emptyMessage="No hay elementos de template"
              >
                <Column
                  header="Id"
                  field="id"
                  style={{ width: "80px" }}
                />
                <Column
                  header="Nombre"
                  body={(rowData) => rowData.archivo?.nombredescarga}
                />
                <Column
                  body={(rowData) => (
                    <Boton
                      texto
                      negro
                      chico
                      callback={(e) => {
                        setSelectedElemento(rowData);
                        menuElementoRef.current.toggle(e);
                      }}
                    >
                      <i className="pi pi-ellipsis-v" />
                    </Boton>
                  )}
                  style={{ width: "60px", textAlign: "center" }}
                />
              </TablaFiltrable>
            </AccordionTab>
          </Accordion>

          <Card css={{ marginTop: "0.5em" }}>
            <TablaFiltrable
              value={templates}
              filtros={FILTROS_TEMPLATES}
              searchFields={SEARCH_FIELDS_TEMPLATES}
              anchoBusqueda="33%"
              nombreArchivo="templates"
              stripedRows
              rows={10}
              emptyMessage="No hay templates"
              selectionMode="single"
              onRowSelect={(e) => {
                const url = `/template/${e.data.id}`;
                if (e.originalEvent.metaKey || e.originalEvent.ctrlKey) {
                  window.open(url, "_blank");
                } else {
                  navigate(url);
                }
              }}
              rowHover
            >
              <Column header="Nombre" field="nombre" />
              <Column
                header="Tipo"
                field="tipo"
                style={{ width: "12rem" }}
                body={(rowData) =>
                  rowData.tipo === "DOCX" ? "Documento Word" : "Script (JS)"
                }
              />
            </TablaFiltrable>
          </Card>
        </div>
      )}
    </>
  );
}
